<div
  class="grid gap-0.5 rounded-md bg-surface-variant p-0.5 w-full"
  [style.--children-count]="children()"
  role="radiogroup"
>
  <ng-content />
</div>
